module.exports = __webpack_public_path__ + "static/media/io.31be5ae0.svg";